import wrapError from "@/components/helpers/wrapError"

export const apiSaveTask = (params, success, error) => {
  $.ajax({
    type: "POST",
    url: "/api/admin/taskManager",
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify(params),
    success,
    error: wrapError(error, "apiCreateTask"),
  })
}

export const apiFetchTasks = (success, error) => {
  $.ajax({
    type: "GET",
    url: "/api/admin/taskManager",
    success,
    error: wrapError(error, "apiFetchTasks"),
  })
}

export const apiDeleteTasks = (taskIds, success, error) => {
  $.ajax({
    type: "PUT",
    url: "/api/admin/taskManager",
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify({ taskIds, type: "delete" }),
    success,
    error: wrapError(error, "apideleteTasks"),
  })
}

export const apiEditTask = (params, success, error) => {
  $.ajax({
    type: "PUT",
    url: "/api/admin/taskManager",
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify({ ...params, type: "edit" }),
    success,
    error: wrapError(error, "apideleteTasks"),
  })
}
